module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/83bea64a7a91dd3527f999f19ad18762.png";